import { z } from 'zod'

export const formatPrice = (price: number | string, dec = 2): string => {
  const currencyFormatter = new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
    style: 'currency',
    currency: 'EUR',
  })

  return currencyFormatter.format(+price)
}

export const getTtc = (priceHT: number, TVA: number): number => {
  const priceTTC = priceHT + (TVA * priceHT) / 100

  return +priceTTC
}

// Return string with accented characters replaced by regular ones
export const replaceAccentedCharactersByRegularOnes = (str: string) =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

// Transform a string text "Je suis un super text" to a id attached "je-suis-un-super-text"
export const getAttachString = (text: string): string =>
  text
    .replace(/[`~!@#$%^&*()|+=?;:'",.<>{}[\]\\/]/g, ' ')
    .replace(/\s\s+/g, ' ')
    .replace(/\s/g, '-')
    .toLowerCase()

export const slugify = (text: string): string => {
  const str = replaceAccentedCharactersByRegularOnes(getAttachString(text))

  if (str.endsWith('-')) {
    return str.substring(0, str.length - 1)
  }

  return str
}

export const formatZodValidationError = (
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  zodError: z.ZodError<Record<string, any>>,
): Partial<Record<string, string>> => {
  return Object.entries(zodError.flatten().fieldErrors).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value?.[0] }),
    {},
  )
}

export const percentage = (num: number, per: number): number => (num / 100) * per

const getMinute = (num: number): number => {
  const percentageMinutes = (num - Math.floor(num)) * 100

  return Math.floor(percentage(percentageMinutes, 60))
}

export const timeConvert = (num: number) => {
  const hours = Math.floor(num)
  const minute = getMinute(num)
  const parsedMinute = minute.toString().padStart(2, '0')
  const parsedHours = hours.toString().padStart(2, '0')

  return `${parsedHours}H${parsedMinute}`
}

export const replaceString = (str: string, from: string, to: string): string => str.replace(new RegExp(from, 'g'), to)

export const insertRelativeImagePath = (urlPath: string) =>
  urlPath[0] === '/' ? `${process.env.API_IZI_BASE_URL}${urlPath.substring(1)}` : urlPath
